module.exports = __webpack_public_path__ + "static/public-79b7830e3626990aab48decb963e0711.svg";